import {gql} from "@apollo/client";
import messageFragment from "../fragments/messageFragment";

const messagesQuery = gql`
    query MessagesQuery(
        $chatGroupId: String
        $offsetId: String
        $limit: Int
        $allowDelinked: Boolean = false
        $isDegreeTypesEnabled: Boolean = false
    ) {
        messages(
            chatGroupId: $chatGroupId
            offsetId: $offsetId
            limit: $limit
            allowDelinked: $allowDelinked
        ) {
            hasMore
            messages {
                ...Message
            }
            chatGroup {
                id
                delinked
                university {
                    id
                    slug
                }
                lastMessage {
                    text
                    created
                }
                unreadMessageCount
                members {
                    id
                    profilePhoto
                }
                opponent {
                    id
                    firstName
                    inboxInfoOne
                    countryCode
                    inboxInfoTwo
                    isEnterprise
                    headlineInfo
                    profilePhoto
                    accountRole
                    isOnline
                    degreeLevel
                    degrees @include(if: $isDegreeTypesEnabled) {
                        degreeType
                        degree {
                            id
                            name
                        }
                    }
                }
                creationSource {
                    id
                    slug
                    type
                    name
                }
            }
        }
    }
    ${messageFragment}
`;

export default messagesQuery;
